import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import SwymWishlistServices from '../hooks/useSwymWishlist'

if (!window.SwymCallbacks) {
  window.SwymCallbacks = []
}
window.SwymCallbacks.push(SwymCallbacksFn)

async function SwymCallbacksFn(swat) {
  const wishlistInstance = new SwymWishlistServices()

  if (await wishlistInstance.fetchLists()) {
    const lid = await wishlistInstance.getListId()
    const listDetails = await wishlistInstance.fetchListDetails(lid)

    if (listDetails) {
      globalEmitter.emit(emitterProps.wishlist.list, listDetails)
    }
  }
}
